export interface Point {
  x: number;
  y: number;
}

export interface Stroke {
  points: Point[];
  color: string;
  width: number;
  tool: 'pen' | 'eraser';
}

export interface DrawingState {
  strokes: Stroke[];
}

export type DrawingStatesMap = Record<string, DrawingState>;

export interface DrawToolbarState {
  isDrawMode: boolean;
  activeColor: string;
  lineWidth: number;
  activeTool: 'pen' | 'eraser';
}

export const PRESET_COLORS = ['#FF0000', '#2196F3', '#4CAF50', '#FFEB3B', '#FFFFFF'] as const;

export const LINE_WIDTHS = [
  { label: 'Thin', value: 2 },
  { label: 'Medium', value: 4 },
  { label: 'Thick', value: 8 },
] as const;
